module.exports = __webpack_public_path__ + "img/m_genre.ded36ea0.svg";